const asArray = (value: string[] | string | undefined): string[] => {
  if (value === undefined) return [];
  return Array.isArray(value) ? value : [value];
};

export default asArray;
